import SessionStorage from './session-storage';
import Vue from "vue";

export default {
    get token() {
        return SessionStorage.get('token')
    },
    set token(value) {
        return value ? SessionStorage.set('token', value) : SessionStorage.remove('token');
    },
    accessToken(email, password) {
        return Vue.http.post('api/login', {
            email,
            password
        }).then((response) => {
            this.token = response.data.token;
        });
    },
    refreshToken() {
        return Vue.http.post('api/refresh_token').then(response => {
            this.token = response.data.token;
            return response;
        });
    },
    getAuthorizationHeader() {
        return `Bearer ${this.token}`;
    },
}
